import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';

export function ProtectedRoute({ children, roles }) {
  const { auth, perfil } = useAuth();
  if (!auth) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(perfil)) return <Navigate to="/" replace />;
  return children;
}
